/**
 * Data model for the Pricing Layers comparison page.
 * Pure data — no component budget. Consumed by CompareTable and CompareStack.
 *
 * Each group has a `title`, optional `note`, and an array of `rows`.
 * Each row has `feature`, `continuity`, `premium` values which are either:
 *   'yes'  → rendered as a green check
 *   'no'   → rendered as a muted dash
 *   any other string → rendered verbatim (e.g. "Self-serve", "By invitation")
 */

export const COMPARE_GROUPS = [
  {
    title: 'Foundations',
    note: '(both tiers)',
    rows: [
      { feature: 'Encrypted personal record of every asset', continuity: 'yes', premium: 'yes' },
      { feature: 'Multi-currency, multi-institution, multi-jurisdiction', continuity: 'yes', premium: 'yes' },
      { feature: 'Direct and indirect holdings (entities, trusts)', continuity: 'yes', premium: 'yes' },
      { feature: '14 investment classes', continuity: 'yes', premium: 'yes' },
      { feature: 'CSV upload from spreadsheets', continuity: 'yes', premium: 'yes' },
    ],
  },
  {
    title: 'Continuity — the quiet safety net',
    note: '(both tiers)',
    rows: [
      { feature: 'Trusted Contacts (add and manage)', continuity: 'yes', premium: 'yes' },
      { feature: 'Encrypted document Continuity System', continuity: 'yes', premium: 'yes' },
      { feature: 'Continuity Assets (automobiles, life insurance, jets, yachts)', continuity: 'yes', premium: 'yes' },
      { feature: 'Quiet 90-day check-in cycle', continuity: 'yes', premium: 'yes' },
      { feature: 'Two-administrator verified release', continuity: 'yes', premium: 'yes' },
      { feature: 'Instant pause or revoke', continuity: 'yes', premium: 'yes' },
    ],
  },
  {
    title: 'Analytical View',
    note: '(Clarity Tier only)',
    rows: [
      { feature: 'Unified dashboard (Overview)', continuity: 'no', premium: 'yes' },
      { feature: 'Portfolio allocation (type / currency / country)', continuity: 'no', premium: 'yes' },
      { feature: 'Performance & Time-Weighted Return', continuity: 'no', premium: 'yes' },
      { feature: 'Benchmark comparison (ACWI, Global Agg, Gold, custom)', continuity: 'no', premium: 'yes' },
      { feature: 'Statement of Net Worth + Liabilities', continuity: 'no', premium: 'yes' },
      { feature: 'Cashflow Calendar (3 / 6 / 9 / 12 months)', continuity: 'no', premium: 'yes' },
      { feature: 'Tax Data Pack (any tax year)', continuity: 'no', premium: 'yes' },
      { feature: 'Current Tax Year Position', continuity: 'no', premium: 'yes' },
      { feature: 'Portfolio sharing (view-only, granular)', continuity: 'no', premium: 'yes' },
      { feature: 'Excel and PDF exports', continuity: 'no', premium: 'yes' },
    ],
  },
  {
    title: 'Security & Privacy',
    note: '(both tiers)',
    rows: [
      { feature: 'Field-level encryption', continuity: 'yes', premium: 'yes' },
      { feature: 'Two-Factor Authentication', continuity: 'yes', premium: 'yes' },
      { feature: 'Google "Quick View" read-only session', continuity: 'yes', premium: 'yes' },
      { feature: 'Zero-knowledge design', continuity: 'yes', premium: 'yes' },
    ],
  },
  {
    title: 'How you join',
    note: '',
    rows: [
      { feature: 'Sign-up', continuity: 'Self-serve', premium: 'By invitation' },
      { feature: 'Pricing', continuity: 'Entry-level annual fee', premium: 'Premium annual fee' },
      { feature: 'Move up any time (record carries over)', continuity: 'yes', premium: '\u2014' },
    ],
  },
];
